
  import { mapState } from 'vuex';
  import { cloneDeep } from "lodash";


  import cart from "@/mixins/cart";
  import search from "@/mixins/search";
  import property from "@/mixins/property";
  import propertyFormat from "@/mixins/propertyFormat";
  import terms from "@/mixins/terms";

  export default {
    name: "PropertyUnitCategory",
    props: {
      unitCategory: {
        type: Object,
        required: true,
      }
    },
    mixins: [
      cart,
      search,
      property,
      terms,
      propertyFormat
    ],
    data() {
      return {
        isOpenGallery: false,
        isOpenRateDetails: false,
        isOpenUnitCategoryInfo: false,
        isOpenSimpleRateSelection: false,
        activeRoomType: null,
        activePromotion: null,
        isOpenTermsAndConditions: false,
        totalQuantity: 0,
        maleIcon: "<i class='mdi mdi-human-male'></i>",
        room_types: [],
        rate_plans: [],
      };
    },
    mounted() {
      this.initTotalQuantity();
      this.initRoomTypes();
      this.initRatePlans();
      // this.filterBestRate();

      if (!this.unitCategory.best_rate) {
        this.isOpenRateDetails = true;
      }
    },
    methods: {
      termsToHtml(str){
        return str.replace(/(?:\r\n|\r|\n)/g, '<br>')
      },
      initRoomTypes() {
        this.room_types = cloneDeep(this.unitCategory.room_types);
        this.room_types.map(room_type => {
          room_type.quantity = this.quantityCartGuest(room_type);
        });

        if (this.property.booking_settings && !this.property.booking_settings.is_show_occupancy) {
          this.room_types = this.room_types.filter(item => {
            return parseInt(item.guests) <= parseInt(this.searchFilters.adults + this.searchFilters.children)
          });
        }
      },
      initRatePlans() {
        this.room_types.map(room_type => {
          if (!room_type.rate_plan_id) {
            return;
          }

          const ratePlan = this.rate_plans.filter(rate_plan => rate_plan.id === room_type.rate_plan_id)[0];

          if (!ratePlan) {
            this.rate_plans.push({
              ...room_type.rate_plan,
              room_types: [room_type]
            });
          } else {
            ratePlan.room_types.push(room_type);
          }
        });
      },
      initTotalQuantity() {
        let quantityCart = 0;

        this.unitCategory.room_types.map(room_type => {
          quantityCart += this.quantityCartGuest(room_type);
        });

        this.totalQuantity = this.unitCategory.availability - quantityCart;
      },
      addCart(roomType) {
        if (!!this.unitCategory.main_image) {
          roomType.image = this.unitCategory.main_image.full_path;
        }

        roomType.unitCategoryName = this.$localize(this.unitCategory.content_name, this.unitCategory.name);

        this.addToCart({
          ...roomType,
          quantity: 1,
          cleaning_fee: this.unitCategory.cleaning_fee,
          currency: this.property.currency ? this.property.currency : 'EUR',
          start_date: this.searchFilters.start_date,
          end_date: this.searchFilters.end_date,
        });
        this.totalQuantity--;
        this.animateBubbletoCart();
      },
      getRefundableDateTerm(ratePlan) {
        let startDate = this.$moment(this.searchFilters.start_date);
        let notRefundableDate = startDate.subtract(ratePlan.refundable_terms + 1, 'days');

        // if (this.$moment(notRefundableDate).isBefore(this.$moment())) {
        //   return this.$moment();
        // }

        return notRefundableDate;
      },
      animateBubbletoCart() {
        if (this.$device.isMobile) {
          location.hash = "#animate-desktop-selection";
        }
      },
      openGallery() {
        this.isOpenGallery = true;
      },
      isRefundable(roomType) {
        if (!roomType.refundable) {
          return false;
        }

        const startDate = this.$moment(this.searchFilters.start_date);
        const notRefundableDate = startDate.subtract(roomType.refundable_terms + 1, 'days');

        return !notRefundableDate.isBefore(this.$moment());
      },
      openTermsAndConditions(roomType) {
        this.activeRoomType = roomType;
        this.isOpenTermsAndConditions = true;

        if (this.hasRoomTypePromotion(roomType)) {
          let promotions = this.getRoomTypePromotions(roomType, this.property);

          if (promotions.length) {
            this.activePromotion = promotions[0];
          }
        }
      },
      bookSimple(roomType) {
        this.$emit('book', {
          ...roomType,
          cleaning_fee: this.unitCategory.cleaning_fee,
        })
      },
      getSimpleRoomTypes(roomTypes) {
        const totalGuests = this.searchFilters.adults + this.searchFilters.children;

        const validCombinations = roomTypes.filter((item) => {
          const children = isNaN(item.children) ? 0 : item.children;
          return parseInt(item.guests) + children >= totalGuests
        });

        return validCombinations.length ? [validCombinations[0]] : [];
      }
    },
    computed: {
      guests() {
        return this.searchFiltersFormatted.guests;
      },
      maxGuestCount() {
        if (!this.unitCategory) {
          return;
        }

        return this.unitCategory.max_occupation;
      },
      ...mapState({
        searchFilters: state => state.search.filters,
      }),
      searchNights() {
        return this.$moment(this.searchFilters.end_date).diff(this.$moment(this.searchFilters.start_date), 'days');
      }
    },
    watch: {
      cartItems: {
        deep: true,
        handler(newVal, oldVal) {
          this.initTotalQuantity();
        },
      },
    },
  };
